import { DatePicker } from "antd";
import dayjs from "dayjs";
import SimpleTablePage from "../common/SimpleTablePage";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";
import { date2locale, greatest } from "../common/common";

const columns = [
  {
    title: "Modello",
    key: "vehicleSetup",
    dataIndex: "vehicleSetup",
    render: (vehicleSetup) => vehicleSetup?.model,
    sorter: true,
    ellipsis: true,
    width: 150,
  },
  {
    title: "Descrizione",
    key: "description",
    dataIndex: "vehicleSetup",
    render: (vehicleSetup) => vehicleSetup?.description,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Targa mezzo",
    key: "plate",
    dataIndex: "vehicleSetup",
    render: (asset) => asset?.plate,
    ellipsis: true,
    width: 180,
  },
  {
    title: "Ultima verifica positiva",
    key: "inspectionDate",
    dataIndex: "inspectionDate",
    render: (_, record) => {
      const gt = greatest(record.vehicleSetup.firstInspectionDate, record.inspection?.date);
      return gt ? date2locale(gt) : "-";
    },
    sorter: true,
    width: 200,
  },
  {
    title: "Scadenza",
    key: "dueDate",
    dataIndex: "dueDate",
    render: (date) => (date ? date2locale(date) : "-"),
    sorter: true,
    width: 150,
  },
  {
    title: "Giorni di ritardo/rimasti",
    key: "daysLeft",
    dataIndex: "dueDate",
    render: (date) => {
      const days = date ? dayjs(date).diff(dayjs().startOf("day"), "day") : null;
      const color = days == null || days < 0 ? "red" : days < 30 ? "orange" : "blue";
      return <span style={{ color }}>{days ?? "MANCANTE"}</span>;
    },
    width: 200,
  },
];

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  {
    name: "vehicleSetup",
    label: "Allestimento",
    readableValue: (value) => value && JSON.parse(value).label,
    formItem: {
      props: {
        getValueProps: (value) => ({ value: value && JSON.parse(value) }),
        normalize: (value) => value && JSON.stringify(value),
      },
      children: (
        <DebounceSelect
          allowClear
          minSize={0}
          fetchOptions={(query) =>
            api.vehicleSetupCurrentInspection
              .list({ query, page: 0, pageSize: 9999 })
              .then(({ data }) =>
                data.map((record) => ({
                  label: `${record.vehicleSetup.model ?? record.vehicleSetup.id} - ${record.vehicleSetup.description ?? ""}`,
                  value: record.vehicleSetup.id,
                })),
              )
          }
        />
      ),
    },
  },
  dateFilter("startDueDate", "Scadenza dal"),
  dateFilter("endDueDate", "Scadenza al"),
];

const fetchInspections = (params) =>
  api.vehicleSetupCurrentInspection.list({
    ...params,
    vehicleSetup: params.vehicleSetup ? JSON.parse(params.vehicleSetup).value : undefined,
  });

export default function VehicleSetupCurrentInspections() {
  return (
    <SimpleTablePage
      title="Verifiche periodiche degli allestimenti"
      description="Consulta le ultime verifiche positive degli allestimenti e le relative scadenze"
      resource="vehicleSetupCurrentInspection"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchInspections}
      rowKey={(record) => record.vehicleSetup.id}
      readOnly
    />
  );
}
